//
// Product view for slings
//
import scrollTo from '../../components/scrollTo/scrollTo'
import CartManager from '../../cart/cart-manager'
import { initVariantsTableSearch, initVariantsTableToggle } from '../../filter-common/filterExtended'
import axios from 'axios'
import { getFreshPrice } from '../../api/variants'
import { getDiscountProductPrice } from '../../api/variants'
;(($) => {
    $(() => {
        const module = $('.new-product-view.slings')
        // Only continue if on product view slings page
        if (!module.length) return

        const params = new URL(document.location.toString()).searchParams;
        const paramVariantId = params.get("variantId"); 
        const productUrlCopyLink = $('#product_url_copy_link');
        productUrlCopyLink.click(() => copyLinkToClipboard());

        const slingsForm = $('#slings-form')
        const slingsFormLoader = $('.slings-form-loader')
        const showAllVariantsLink = $('.npp__show-all-variants')
        const showContactUsTab = $('.npp__show-contact-us')
        const showMoreButton = $('.show-more__button')
        const increaseButton = $('.button-increase')
        const decreaseButton = $('.button-decrease')
        const quantityInput = $('.input-quantity')
        const priceDiv = $('.npp__price')
        const stockDiv = $('.npp__stock--info')
        const partCodeDiv = $('.npp__title--heading2')
        const stockModal = $('#stockModal')
        const data = JSON.parse(slingsForm.attr('data-variants'))
        const variantsTab = document.querySelector('#variants')
        const contactUsTab = document.querySelector('#contact-us')
        const productInformationTab = document.querySelector('#product-information')
        let variants = data.variants
        const options = data.options
        const cartWidgetAttributes = data.options.cartWidgetAttributes
        let selectedVariant
        const excludeVat = $('.exclude-vat');

        showMoreButton.click(() => goToAndOpenTab(productInformationTab))
        showAllVariantsLink.click(() => goToAndOpenTab(variantsTab))
        showContactUsTab.click(() => goToAndOpenTab(contactUsTab))

        const goToAndOpenTab = (target) => {
            if (target) {
                target.click()
                scrollTo(target, -160)
            }
        }

        quantityInput.on('change', (e) => {
            let currentQuantity = parseInt(e.currentTarget.value)
            if (currentQuantity <= 0 || isNaN(currentQuantity)) {
                quantityInput.val(1)
            }
            refreshPrice()
        })

        increaseButton.on('click', (e) => {
            incrementQuantity(e)
            refreshPrice()
        })

        decreaseButton.on('click', (e) => {
            decrementQuantity(e)
            refreshPrice()
        })

        slingsForm.on('submit', (e) => {
            e.preventDefault()
            if (options.showAddToCart) {
                sendGeneric(slingsForm)
            } else {
                sendQuote()
            }
        })

        const incrementQuantity = (e) => {
            e.preventDefault()
            let currentQuantity = parseInt(quantityInput.val(), 10)

            if (!isNaN(currentQuantity)) {
                quantityInput.val(currentQuantity + 1)
            } else {
                quantityInput.val(0)
            }
        }

        const decrementQuantity = (e) => {
            e.preventDefault()
            const currentQty = getQuantity()
            if (!isNaN(currentQty) && currentQty > 1) {
                quantityInput.val(currentQty - 1)
            } else {
                quantityInput.val(1)
            }
        }

        const getQuantity = () => parseInt(quantityInput.val(), 10)

        const getLocaleCode = () => $('html').attr('data-locale').replace('_', '-')

        const getPriceFormatted = (price) => {
            return new Intl.NumberFormat(getLocaleCode(), {
                style: 'currency',
                currency: selectedVariant.currencyCode,
            }).format(price)
        }

        const getIndexByKeys = (obj, primaryKey, secondaryKey) => {
            let idx = obj.findIndex((variant) => variant[primaryKey] && variant[secondaryKey])
            if (idx === -1) {
                idx = obj.findIndex((variant) => variant[primaryKey])
            }
            if (idx === -1) {
                idx = obj.findIndex((variant) => variant[secondaryKey] > 0)
            }
            if (idx === -1) {
                idx = 0
            }
            return idx
        }

        const setFirstAvailableVariant = (variants) => {
            let firstAvailableVariantIdx = getIndexByKeys(variants, 'Price', 'Stock')
            if (firstAvailableVariantIdx !== -1 && firstAvailableVariantIdx < variants.length) {
                variants[firstAvailableVariantIdx].selected = true
            } else {
                console.error('No valid variant found to set as selected')
            }
            return variants
        }

        const checkVariantsData = (variants, cartWidgetAttributes) => {
            cartWidgetAttributes.forEach((attribute) => {
                variants.map((variant) => {
                    if (!variant[attribute]) {
                        variant[attribute] = `${window.globals.trans('product-page.not-specified')}`;
                    }
                });
            });
        
            return variants;
        };

        const updateVariantsObject = (newData) => {
            variants.find((variant) => {
                if (variant === selectedVariant) {
                    Object.keys(newData).forEach((item) => {
                        variant[item] = newData[item]
                    })
                }
            })
        }

        const shouldDisplayDualPrices = (normalPrice, discountPrice) => {
            return (
                options.isCustomerUniquePriceActive &&
                options.displayDualPrices &&
                discountPrice !== undefined &&
                discountPrice !== '-' &&
                normalPrice !== String(discountPrice)
            )
        }

        const displayDualPrices = (normalPrice, discountPrice) => {
            const normalPriceElement = $('<span></span>')
                .addClass('price-text line-through')
                .css('opacity', '0.5')
                .css('margin-right', '10px')
                .html(getPriceFormatted(normalPrice))

            const discountPriceElement = $('<span></span>').addClass('fresh-price-text').html(getPriceFormatted(discountPrice))

            priceDiv.append(normalPriceElement)
            priceDiv.append(discountPriceElement)
        }

        const displayPrice = async (normalPrice) => {
            let priceToDisplay

            if (options.isCustomerUniquePriceActive) {
                try {
                    if (options.erpPrice) {
                        priceToDisplay = await fetchUniquePrice()
                    } else {
                        priceToDisplay = await fetchDiscountPrice()
                    }
                } catch (error) {
                    console.error('Error fetching price:', error)
                    priceToDisplay = normalPrice
                }
            }

            if (!priceToDisplay) {
                priceToDisplay = normalPrice
            }

            priceDiv.empty()

            if (normalPrice !== null) {
                if (shouldDisplayDualPrices(normalPrice, priceToDisplay)) {
                    displayDualPrices(normalPrice, priceToDisplay)
                } else {
                    displaySinglePrice(priceToDisplay === '-' ? normalPrice : priceToDisplay)
                }
            } else {
                priceDiv.empty()
            }
        }

        const displaySinglePrice = (priceToDisplay) => {
            if (priceToDisplay !== undefined) {
                const multiplication = getQuantity() * priceToDisplay
                priceDiv.html(getPriceFormatted(multiplication))
                excludeVat.css('display', 'inline-block')
            } else {
                priceDiv.empty()
            }
        }

        const displayBatchPrice = (selectedVariant) => {
            priceDiv.html(selectedVariant.BatchPriceFormattedWithPacking ?? selectedVariant.PriceFormatted)
            excludeVat.css('display', 'inline-block')
        }

        const fetchUniquePrice = () => {
            return new Promise((resolve, reject) => {
                slingsFormLoader.show()
                priceDiv.append('<div class="loader"></div>')
                getFreshPrice(selectedVariant.PartCode)
                    .then((res) => {
                        const freshPriceData = res.data
                        updateVariantsObject(freshPriceData)
                        resolve(freshPriceData.Price)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
                    .finally(() => {
                        slingsFormLoader.hide()
                        selectedVariant.priceRefreshed = true
                        priceDiv.find('.loader').remove()
                    })
            })
        }

        const fetchDiscountPrice = () => {
            return new Promise((resolve, reject) => {
                slingsFormLoader.show()
                priceDiv.append('<div class="loader"></div>')
                getDiscountProductPrice(selectedVariant.id)
                    .then((res) => {
                        const freshPriceData = res.data
                        updateVariantsObject(freshPriceData)
                        resolve(freshPriceData.Price)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
                    .finally(() => {
                        slingsFormLoader.hide()
                        selectedVariant.priceRefreshed = true
                        priceDiv.find('.loader').remove()
                    })
            })
        }

        const refreshPrice = async () => {
        
            if (!selectedVariant) {
                console.error('Selected variant is undefined')
                return
            }
        
            if (options.isBatchPrice) {
                await displayBatchPrice(selectedVariant)
                return
            }
        
            await displayPrice(selectedVariant.Price)
        }
        
        const getStockLevel = () => {
            if (!selectedVariant) {
                console.error('Selected variant is undefined')
                return 0
            }
            return parseInt(selectedVariant.Stock)
        }
        
        const getAvailabilityLabel = (stockLevel, showUnits = false) => {
            let stockText = stockLevel > 0 ? `${window.globals.trans('filter.in_stock')}` : `${window.globals.trans('filter.out_of_stock')}`
            if (showUnits && stockLevel > 0) {
                stockText += ` (${stockLevel} ${window.globals.trans('units')})`
            }
            return stockText
        }
        const getAvailabilityIndicatorClass = (stockLevel) => (stockLevel > 0 ? 'stock in' : 'stock out')

        const generateStockInfo = (stockLevel) =>
            `<span class="stock-text">${getAvailabilityLabel(stockLevel)}</span> <span class="${getAvailabilityIndicatorClass(stockLevel)}"></span>`
        const generateStockWarehouseInfo = (stockLevel) =>
            `<span class="${getAvailabilityIndicatorClass(stockLevel)}"></span> <span class="stock-text">${getAvailabilityLabel(stockLevel, true)}</span>`

        const refreshStock = () => {
            const stockLevel = getStockLevel()

            if (!isNaN(stockLevel)) {
                stockDiv.html(generateStockInfo(stockLevel))
            } else {
                stockDiv.html(
                    `<span class="stock-text"><a href="${slingsForm.attr('data-contact-url')}" class="ask" target="_blank">${window.globals.trans(
                        'filter.ask',
                    )}</a></span> <span class="stock no"></span>`,
                )
            }
        }
        const generateWarehousesTable = (warehouses) => {
            const tableBody = document.querySelector('#warehousesTable tbody')

            if (warehouses && warehouses.length > 0) {
                const populateTable = (warehouses) => {
                    tableBody.innerHTML = warehouses
                        .map(
                            ({ name, stock }) => `
                <tr>
                    <td class="stock-modal__name">${name}</td>
                    <td class="stock-modal__stock">${generateStockWarehouseInfo(stock)}</td>
                </tr>
            `,
                        )
                        .join('')
                }
                populateTable(warehouses)
            } else {
                tableBody.innerHTML = `<tr><td colspan="2" class="text-center font-italic">${window.globals.trans(
                    'product-page.no-warehouses-message',
                )}</td></tr>`
            }
        }

        const refreshStockModalData = () => {
            const partCode = selectedVariant.PartCode
            const warehouses = selectedVariant.warehouses
            stockModal.find('.stock-modal__partcode').html(`<span class="bold">${window.globals.trans('product-page.product-number')}</span>: ${partCode}`)
            generateWarehousesTable(warehouses)
        }

        const refreshPartCode = () => {
            const partCode = selectedVariant.PartCode
            partCodeDiv.text(partCode)
        }

        const generateDropdowns = (data) => {
            // Create a mapping of keys to labels
            const columnsMap = data.columns.reduce((map, column) => {
                map[column.key] = column.label;
                return map;
            }, {});

            // Find the placeholder element
            const placeholder = document.querySelector('.npp__slings-form .form-group');
            const referenceNode = placeholder.lastElementChild;

            // Generate select elements for each attribute in cartWidgetAttributes
            cartWidgetAttributes.forEach((attr) => {
                const formItemDiv = document.createElement('div');
                formItemDiv.className = 'form-item';

                const label = columnsMap[attr];
                const select = document.createElement('select');
                select.id = `select-${attr}`;
                select.className = 'form-control';

                const labelElement = document.createElement('label');
                labelElement.innerHTML = label;
                labelElement.setAttribute('for', select.id);

                formItemDiv.appendChild(labelElement);
                formItemDiv.appendChild(select);
                placeholder.insertBefore(formItemDiv, referenceNode);

                /* Fix for LISXGPIM-312 */
                document.querySelectorAll('.custom_br_Remove br').forEach((br) => {
                    const span = document.createElement('span');
                    span.className = 'line-break';
                    span.innerHTML = ' ';
                    br.replaceWith(span);
                  });
            });

            // Initialize selectric
            cartWidgetAttributes.forEach(attr => {
                $(`#select-${attr}`).selectric({
                    onChange: () => {
                        updateNextSelects(cartWidgetAttributes.indexOf(attr));
                        setSelectedVariant();
                        refreshPrice();
                        refreshStock();
                        refreshPartCode();
                        refreshStockModalData();
                    }
                });
            });

            // Populate the first select element
            const firstAttr = cartWidgetAttributes[0];
            const firstSelect = document.getElementById(`select-${firstAttr}`);
            const uniqueValues = [...new Set(data.variants.map(variant => variant[firstAttr]))];

            uniqueValues.forEach((value, index) => {
                const option = document.createElement('option');
                option.value = value;
                option.text = value;
                if (paramVariantId) {
                    const selectedVariantObj = variants.find(product => product.id == paramVariantId);
                    if (selectedVariantObj) {
                        const firstAttrSelect = selectedVariantObj[firstAttr];
                        if (value == firstAttrSelect) {
                            option.selected = true;
                        }
                    } else {
                        if (index === 0) {
                            option.selected = true;
                        }
                    }
                } else {
                    const selectedVariantObj = variants.find(product => product.selected == true);
                    if (selectedVariantObj) {
                        const firstAttrSelect = selectedVariantObj[firstAttr];
                        if (value == firstAttrSelect) {
                            option.selected = true;
                        }
                    } else {
                        if (index === 0) {
                            option.selected = true;
                        }
                    }
                }
                firstSelect.appendChild(option);
            });

            // Initialize selectric for the first select
            $(`#select-${firstAttr}`).selectric();

            // Function to update the next select elements based on the previous select's value
            const updateNextSelects = (currentIndex) => {
                for (let i = currentIndex + 1; i < cartWidgetAttributes.length; i++) {
                    const currentAttr = cartWidgetAttributes[i - 1];
                    const nextAttr = cartWidgetAttributes[i];
                    const currentSelect = document.getElementById(`select-${currentAttr}`);
                    const nextSelect = document.getElementById(`select-${nextAttr}`);
                    const selectedValue = currentSelect.value;
                    let filteredVariants = data.variants.filter(variant => variant[currentAttr] === selectedValue);

                    // Filter variants based on all previous selects
                    for (let j = 0; j < i - 1; j++) {
                        const prevAttr = cartWidgetAttributes[j];
                        const prevSelect = document.getElementById(`select-${prevAttr}`);
                        const prevSelectedValue = prevSelect.value;
                        filteredVariants = filteredVariants.filter(variant => variant[prevAttr] === prevSelectedValue);
                    }

                    const uniqueNextValues = [...new Set(filteredVariants.map(variant => variant[nextAttr]))];

                    // Clear previous options
                    nextSelect.innerHTML = '';

                    uniqueNextValues.forEach((value, index) => {
                        const option = document.createElement('option');
                        option.value = value;
                        option.text = value;

                        if (paramVariantId) {
                            const selectedVariantObj = variants.find(product => product.id == paramVariantId);
                            if (selectedVariantObj) {
                                const nextAttrSelect = selectedVariantObj[nextAttr];
                                if (value == nextAttrSelect) {
                                    option.selected = true;
                                }
                            } else {
                                if (index === 0) {
                                    option.selected = true;
                                }
                            }
                        } else {
                            const selectedVariantObj = variants.find(product => product.selected == true);
                            if (selectedVariantObj) {
                                const nextAttrSelect = selectedVariantObj[nextAttr];
                                if (value == nextAttrSelect) {
                                    option.selected = true;
                                }
                            } else {
                                if (index === 0) {
                                    option.selected = true;
                                }
                            }
                        }
                        nextSelect.appendChild(option);
                    });

                    // Initialize selectric for the next select
                    $(`#select-${nextAttr}`).selectric('refresh');
                }
            };

            // Function to set the selected variant based on the current select values
            const setSelectedVariant = () => {
                selectedVariant = data.variants.find(variant => {
                    return cartWidgetAttributes.every(attr => {
                        const select = document.getElementById(`select-${attr}`);
                        return variant[attr] === select.value;
                    });
                });

                if (selectedVariant.id) {
                    let url = window.location.href;

                    // Check if the URL has a '#' at the end and remove it
                    if (url.endsWith('#')) {
                        url = url.slice(0, -1);
                    }

                    if (url.indexOf('?') !== -1) {
                        if (url.indexOf('variantId=') !== -1) {
                            url = url.replace(/(variantId=)([^&]*)/, '$1' + selectedVariant.id);
                        } else {
                            url += '&variantId=' + selectedVariant.id;
                        }
                    } else {
                        url += '?variantId=' + selectedVariant.id;
                    }

                    $("#product_url_copy_link").attr("data-url", url)
                }
            };

            // Initial population of the second select and beyond
            updateNextSelects(0);

            // Set the initial selected variant and refresh data
            setSelectedVariant();
            refreshPrice();
            refreshStock();
            refreshPartCode();
            refreshStockModalData();
        };

        const init = () => {
            variants = setFirstAvailableVariant(variants)
            variants = checkVariantsData(variants, cartWidgetAttributes)
            generateDropdowns(data);
            refreshPrice()
            refreshStock()
            refreshPartCode()
            refreshStockModalData()
            initVariantsTableSearch()
            initVariantsTableToggle()
        }

        const postData = (data) => {
            axios({
                method: 'post',
                url: slingsForm.attr('data-action-url'),
                data: data,
            })
                .then((response) => {
                    const data = response.data
                    CartManager.updateCoreshopCartCount(data)
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'add_to_cart',
                            ecommerce: {
                                currency: data.currencyCode || '',
                                items: [
                                    {
                                      item_id: data.id.toString(),
                                      item_name: data.name,
                                      price: data.price || '0',
                                      quantity: parseInt(data.qty, 10),
                                      item_category: data.category || ''
                                    }
                                ]
                            },
                        })
                    }
                })
                .catch((err) => {
                    throw err
                })
        }

        const sendGeneric = () => {
            const data = {
                quantity: getQuantity().toString(),
                product: selectedVariant.id.toString(),
            }
            postData(data)
        }

        const sendQuote = () => {
            const quantity = getQuantity().toString()
            const variantId = selectedVariant.id.toString()
            CartManager.addToCart(variantId, quantity)
        }

        const copyLinkToClipboard = () => {
            return new Promise((resolve, reject) => {
                try {
                    var urlToCopy = $('#product_url_copy_link').attr('data-url');
                    var $tempInput = $('<input>');
                    $('body').append($tempInput);
                    $tempInput.val(urlToCopy).select();
                    document.execCommand('copy');
                    $tempInput.remove();
                    $('#copy-message').fadeIn().delay(2000).fadeOut();
                    resolve('URL copied successfully');
                } catch (error) {
                    console.error('Failed to copy URL:', error);
                    reject('Failed to copy URL');
                }
            });
        };

        if (variants.length > 0) init()
    })
})(jQuery)
